import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: "currentColor",
      strokeWidth: "2",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "16.286",
        cy: "7.714",
        r: "1.905"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.333 15.333a6.667 6.667 0 1 0-6.22-4.261L2 18.19V22h3.81L8 19.69V17h2.714l2.213-2.114a6.65 6.65 0 0 0 2.406.447Z"
      })]
    }), /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16.286 4.81a2.905 2.905 0 1 0 0 5.81 2.905 2.905 0 0 0 0-5.81Zm-.905 2.904a.905.905 0 1 1 1.81 0 .905.905 0 0 1-1.81 0Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.333 1a7.667 7.667 0 0 0-7.364 9.803L1 17.776V23h5.24L9 20.09V18h2.115l2.065-1.973A7.667 7.667 0 1 0 15.333 1ZM9.667 8.667a5.667 5.667 0 1 1 3.62 5.286l-.592-.23L10.313 16H7v3.292L5.38 21H3v-2.395l7.281-7.287-.235-.607a5.65 5.65 0 0 1-.38-2.044Z"
      })]
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconProductKey24 = createIcon(IconComponent);